import { RoundArray as t } from "../../utils/array/index4.js";
function u(r, o) {
  return r.fromArray(t(r.toArray(), o));
}
export {
  u as RoundVector
};
//# sourceMappingURL=index25.js.map
